import type { GameState } from "../types/index.js";

export function reject(state: GameState, reason: string): GameState {
  return { ...state, lastRejection: reason };
}

export function accept(state: GameState): GameState {
  return { ...state, lastRejection: null };
}
